import type { HttpGetWithMeta } from '@/shared/infra/http'
import type { GalleryPhoto } from '@/shared/domain'
import type { ListGalleryPhotos } from '@/modules/gallery/use-cases'
import { buildGalleryQueryString } from './build-gallery-query-string'

export class SupabaseListGalleryPhotosRepository {
  constructor(private readonly http: HttpGetWithMeta) {}

  execute: ListGalleryPhotos = async (params) => {
    const { data, meta } = await this.http.getWithMeta<{ photos: GalleryPhoto[] }>({
      url: `/club-gallery-photos${buildGalleryQueryString(params)}`,
    })
    return { photos: data.photos, total: (meta?.total as number) ?? data.photos.length }
  }
}
